module.exports = __webpack_public_path__ + "static/img/Sela_h5.2d06c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Sela_h5.png
// module id = ERcE
// module chunks = 34